import { FC, useEffect, useState } from "react";
import NavBar from "./components/Layout/NavBar";
import Header from "./components/Layout/Header";
import Footer from "./components/Layout/Footer";
import About from "./components/About/About";
import NavPills from "./components/NavPill/NavPills";
import ModuleOverview from "./components/Modules/ModulesOverview";
import ReleaseOverview from "./components/ReleaseOverview/ReleaseOverview";
import { getReleases } from "./api/backendApi";
import { Release } from "models/release";

const App: FC = () => {
    const [modules, setModules] = useState<string[]>([]);
    const [activeModule, setActiveModule] = useState<string>();
    const [releases, setReleases] = useState<Release[] | null>(null);
    const [selectedModuleReleases, setSelectedModuleReleases] = useState<Release[]>([]);
    const [selectedRelease, setSelectedRelease] = useState<Release | null>(null);

    useEffect(() => {
        const apiGet = async () => {
            try {
                const data = await getReleases();
                setReleases(data);
                setModules(Array.from(new Set(data.map(d => d.module))));
            } catch {
                setReleases([]);
            }
        };
        void apiGet();
    }, []);

    useEffect(() => {
        if(!activeModule || !releases) {
            setSelectedModuleReleases([] );
            return;
        }
        
        setSelectedModuleReleases(releases.filter(r => r.module === activeModule));
    }, [activeModule, releases]);

    return (
        <>
            <NavBar />
            <Header />
            <section className="container white develop-content" id="content">
                <About />

                <section className="container-padding"></section>

                <NavPills modules={modules} contentCallback={setActiveModule} />

                { !releases && "Loading releases..."}
                
                {activeModule && (
                    <ModuleOverview
                        releases={selectedModuleReleases}
                        onReleaseSelect={(release) =>
                            setSelectedRelease(release)
                        }
                        activeModule={activeModule}
                        selectedRelease={selectedRelease}
                    />
                )}

                {selectedRelease && (
                    <ReleaseOverview
                        release={selectedRelease}
                        onClose={() => setSelectedRelease(null)}
                    />
                )}

                <section className="container-padding"></section>
            </section>
            <Footer />
        </>
    );
};

export default App;
